import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
import {BooleanRadios} from "../form/fields/BooleanRadios";
import {Col, Row, Container} from "reactstrap";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
 
 
export class StateFormData {
    @observable name = '';
    @observable code = '';
    @observable capital = null;
    @observable is_active = true;
}

export class StateForm extends CrudForm {
    modelName = 'State';

    renderFields() {
        return (
            <>
                <Field
                    label="Name"
                    name="name"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />

                <Field
                    label="Code"
                    name="code"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />

                <Field
                    label="Capital"
                    name="capital"
                    component={Input}
                    store={this.formStore}
                />

                <Field
                    name="is_active"
                    component={BooleanRadios}
                    trueLabel="Active"
                    falseLabel="In-Active"
                    store={this.formStore}
                />
            </>
        );
    }
}

export class StateFilterForm {
    @observable name = '';
}

export class StateList extends CrudList {
    modelName = 'State';
    defaultSortColumn = 'name';
    defaultSortDirection = 'asc';

    colums() {
        return [
            {
                name: "code",
                label: "Code",
                sort:true,
            },
            {
                name: "name",
                label: "Name",
                sort:true
            },
            {
                name: "capital",
                label: "Capital",
                sort:true
            },
        ];
    }

    idColumn() {
        return '';
    }

    renderFilters() {
        return (

            <Container>
            <Row className="form-row">
                 <Col md={5}>
                     <ToastContainer autoClose={5000} />
                 </Col>
            </Row>
            
            <Row className="form-row">
                <Col md={3} lg={4} xl={3}>
                    <Field
                        placeholder="Name"
                        name="name"
                        component={Input}
                        store={this.filterFormStore}
                    />
                </Col>

                <Col md={3} lg={4} xl={3} className="grid-search">
                    {this.renderSearch()}
                </Col>
            </Row>
            </Container>
        );
    }
}

export class StatePage extends CrudPage {
    modelName = 'State';
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/StatePage.tsx